import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { withStyles, createStyleSheet } from 'material-ui/styles';
import { CircularProgress, Button } from 'components';

const styleSheet = createStyleSheet('LoadMoreButton', () => {
  return {
    button: {
      width: '100%',
    },
    progress: {
      color: 'white',
    },
  };
});

const LoadMoreButton = ({
  className,
  classes,
  onClick,
  hasMore,
  loading,
  children,
  ...rest
}) => {
  if (!hasMore) return null;

  return (
    <Button
      raised
      color="primary"
      {...rest}
      className={classNames(classes.button, className)}
      onClick={onClick}
      disabled={loading}
    >
      {loading
        ? <CircularProgress size={25} className={classes.progress} />
        : children}
    </Button>
  );
};

LoadMoreButton.propTypes = {
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any,
};

LoadMoreButton.defaultProps = {
  hasMore: true,
  loading: false,
  onClick: () => {},
  children: '더보기',
};

export default withStyles(styleSheet)(LoadMoreButton);



// WEBPACK FOOTER //
// ./src/common/components/LoadMoreButton.js